import Button from 'components/Button'
import TableSearchFilter from 'components/UIComponents/TableSearchFilter'
import React, { useState } from 'react'
import CandidateRatingFilter from './Partials/ScoreFilter'
import { FilterText, MenuFlex, StyledTab, SubmitFlex } from './Styles/style'

import StatusFilter from './Partials/StatusFilter'

const { TabPane } = StyledTab

const RolesFilter = ({
  jobsList,
  searchValue,
  setSearchValue,
  filterData,
  setFilterData,
  jobTypeLevel,
  setJobTypeLevel,
  jobType,
  setJobType,
  postedDate,
  setPostedDate,
  filterStatus,
  setFilterStatus,
  setPageNum,
  statusFilter,
  setStatusFilter,
  candidateRating,
  setCandidateRating,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const submitFilter = () => {
    setFilterData({
      status: statusFilter,
      score: candidateRating,
    })

    setIsMenuOpen(false)
  }

  const onCancelFilter = open => {
    setIsMenuOpen(!isMenuOpen)
    if (!open) {
      setStatusFilter(filterData?.statusFilter)
      setCandidateRating(filterData?.candidateRating)
    }
  }

  const menu = (
    <MenuFlex column className="filter">
      <FilterText>FILTER BY </FilterText>
      <StyledTab
        border={true}
        tabPosition={'left'}
        type="card"
        padding="15px"
        popupClassName="filter"
        textColor={'#3249D7'}
        overflowX={'hidden'}
      >
        <TabPane tab="Status" key="1">
          <StatusFilter
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
          />
        </TabPane>
        <TabPane tab="Score" key="2">
          <CandidateRatingFilter
            candidateRating={candidateRating}
            setCandidateRating={setCandidateRating}
            labelText={'Score'}
          />
        </TabPane>
      </StyledTab>
      <SubmitFlex right>
        <Button.Secondary text="Cancel" onClick={() => onCancelFilter(false)} />
        <Button.Primary onClick={submitFilter} text="Apply Filter" />
      </SubmitFlex>
    </MenuFlex>
  )

  return (
    <TableSearchFilter
      backgroundColor={true}
      menu={menu}
      open={isMenuOpen}
      setOpen={setIsMenuOpen}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      totalCount={jobsList?.count}
      currentCount={
        jobsList?.count < 10
          ? jobsList?.count
          : jobsList?.result?.length + jobsList?.page * 10
      }
      onOpenChange={onCancelFilter}
    />
  )
}

export default RolesFilter
